import React, { useState, useEffect } from "react";
import DataTable from "../../../Common/Components/DataTable";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { GetData, DeleteData } from "./Components/Services";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import CommonFrom from "../../../Common/Components/Form";
import { input } from "./Create";
import Loading from "../../../Common/Components/Loading";
import { ToDateJalali } from "../../../Common/Function";

function List() {
  const initialState = {
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
    modal: false,
    type: null,
  };
  const [state, setstate] = useState(initialState);
  const [filter, setfilter] = useState({});
  const Handler = (data, pageNumber = 1) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, data, filter).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };

  const checkEmpty = data => {
    switch (data) {
      case null:
      case undefined:
      case "":
        return false;

      default:
        return true;
    }
  };

  const checkKindModal = data => {
    switch (data && data[0].type) {
      case "choach":
        return <ShowDeatailsCoach data={data[state.modal - 1]} />;
      case "institution":
        return <ShowDeatailsInstitution data={data[state.modal - 1]} />;

      default:
        break;
    }
  };

  const HandlerDelete = data => {
    setstate({ ...state, loading: true });
    DeleteData(data).then(() => {
      GetData().then(result => {
        setstate({
          data: result,
          loading: false,
        });
      });
    });
  };
  useEffect(() => {
    Handler();
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | درخواست ها</title>
      </Helmet>

      <Fragment>
        {checkEmpty(state.data) ? (
          <DataTable
            loading={state.loading}
            filter={true}
            heads={[
              {
                title: "نوع درخواست",
                key: "type",
                type: "enum",
                enum: {
                  choach: "مربی",
                  institution: "مجموعه",
                },
              },

              ,
              {
                title: "نام",
                key: "form_details",
                keyName: "fullname",
              },
            ]}
            textEmpty="درخواستی ثبت نشده"
            list={state.data && state.data[0] && state.data[0].data}
            data={state.data[0]}
            function={Handler}
            currentPage={
              state.data && state.data[0] && state.data[0].current_page
            }
            header=" لیست درخواست"
            messageToast="برای نمایش درخواست ها ابتدا نوع درخواست را انتخاب نمایید."
            links={[
              {
                function: selected => {
                  setstate({ ...state, modal: selected[0] });
                },
                color: "block",
                type: "key",
                size: "col-md-8",
                html: (
                  <Fragment>
                    <select
                      onChange={e => {
                        Handler(null, null, e.target.value);
                      }}
                      className="form-control"
                    >
                      <option>نوع درخواست</option>
                      <option value="coach">ارتقا مربیان</option>
                      <option value="institution">ثبت مجموعه</option>
                    </select>
                    <select
                      onChange={e => {
                        Handler(null, null, { status: e.target.value });
                      }}
                    >
                      <option>وضعیت</option>
                      <option value="">مشاهده همه</option>
                      <option value="waiting">در انتظار</option>
                      <option value="cansel">لغو شده</option>
                      <option value="done">تایید شده</option>
                    </select>
                  </Fragment>
                ),
              },
              {
                function: () => {
                  Handler(null, null, filter);
                },
                color: "info",
                size: "col-md-4",
                html: "فیلتر",
              },
              {
                function: selected => {
                  HandlerDelete({ joining_id: selected[0] });
                },
                color: "danger",
                size: "col-md-2",
                html: "حذف",
                multi: true,
                type: "delete",
              },

              {
                function: selected => {
                  setstate({ ...state, modal: selected[0] });
                },
                color: "info",
                type: "key",
                size: "col-md-2",
                html: "جزئیات",
                type: "show",
                main: true,
              },
            ]}
          />
        ) : (
          <span>اطلاعات موجود نیست</span>
        )}
      </Fragment>

      <CustomModal
        show={state && state.modal}
        handleClose={() => {
          setstate({ ...state, modal: false });
        }}
        header={"جزئیات درخواست"}
      >
        {checkKindModal(state.data.data)}
      </CustomModal>
    </Fragment>
  );
}
export const ShowDeatailsCoach = ({ data }) => {
  return (
    <div className="">
      <ul>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>نام</span>
          <span>{data && data.form_details.fullname} </span>
        </li>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>سابقه :</span>
          <span>{data && data.form_details.History}</span>
        </li>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>افتخارات:</span>
          <span>{data && data.form_details.Honors}</span>
        </li>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>تاریخ تولد:</span>
          <span>{ToDateJalali(data && data.form_details.brday)}</span>
        </li>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>شماره پیگیری</span>
          <span>{data && data.form_details.nationalnumber}</span>
        </li>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>شماره تلفن:</span>
          <span>{data && data.form_details.telnumber}</span>
        </li>
        <li className="d-flex p-2 m-2 justify-content-center">
          <img
            className="img-fluid"
            width={200}
            height={200}
            src={data && data.images[0]}
          ></img>
        </li>
      </ul>
    </div>
  );
};
export const ShowDeatailsInstitution = ({ data }) => {
  return (
    <div className="">
      <ul>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span> نام درخواست دهنده </span>
          <span>{data && data.form_details.fullname} </span>
        </li>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>نام مدیر مجموعه :</span>
          <span>{data && data.form_details.itemadminname}</span>
        </li>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>شماره تلفن مدیر باشگاه :</span>
          <span>{data && data.form_details.itemadmintel}</span>
        </li>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>نام مجموعه:</span>
          <span>{data && data.form_details.itemfullname}</span>
        </li>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>شماره تلفن مجموعه </span>
          <span>{data && data.form_details.itemtel}</span>
        </li>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>ورزش های موجود:</span>
          <span>{data && data.form_details.sports}</span>
        </li>
        <li className="d-flex border border-light p-2 m-2 justify-content-between">
          <span>نوع درخواست:</span>
          <span>
            {data && data.form_details.typereq == "me"
              ? "مالک باشگاه"
              : "پیشنهاد دهنده"}
          </span>
        </li>
      </ul>
    </div>
  );
};
export default List;
